import Vue from "vue";
//Plugins
import BountixpFormFramework from 'bountixp-form-framework'
import { BxpButton } from 'bountixp-form-framework' //Custom button for use in the multistep form wizard
import FormWizard from 'vue-multistep-form-wizard'
import VuetifyPhoneField from 'vuetify-phone-field'
import Router from "vue-router"
import vuetify from "./plugins/vuetify"
import VueScrollTo from "vue-scrollto"

import App from "./App.vue";
import { formBus } from './formBus'

import { VSelect, VTextField } from 'vuetify/lib'
Vue.use(VuetifyPhoneField, {
  VSelect,
  VTextField
})

Vue.use(BountixpFormFramework, {formBus});
Vue.use(FormWizard, {
  steps: [
    {
      title: 'Step 1',
      component: 'Step1',
      valid: false
    },
    {
      title: 'Step 2',
      component: 'Step2',
      valid: false
    }
  ],
  topBar: 'none',
  displayMode: 'fitContainer',
  progressBar: {
    position: 'top',
    attach: 'bxp_layout_content'
  },
  tabNavigation: 'nextOnly',
  customButton: BxpButton
});
Vue.use(Router);
const router = new Router({
  base: "/enterprise-enquiry",
  mode: "history"
});
Vue.use(VueScrollTo);

new Vue({
  el: "#bountixp_enterprise_enquiry_form_1",
  router,
  vuetify,
  render: h => h(App)
});
